import { models } from 'powerbi-client';
import { PowerBIEmbed } from 'powerbi-client-react';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { injectIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { Div, Flex } from 'ui';
import useDeepCompareEffect from 'use-deep-compare-effect';
import { powerBi, powerBiConfigScopes } from '../../utils/app-configs';
import useADLogin from '../../utils/useADLogin';

const StyledDiv = styled(Div)`
  .power-bi-report {
    height: 77vh;
    margin-top: 20px;
  }
  .power-bi-report > iframe {
    border: none;
  }
`;

const PowerBiReport = ({
  id,
  intl,
}) => {
  const powerBiReports = useSelector(state => state.powerBiReports.powerBiReports);

  const [powerBiPromptLogin, setPowerBiPromptLogin] = useState('none');
  const [powerBiAccessToken, setPowerBiAccessToken] = useState(null);
  const [canShowReport, setCanShowReport] = useState(true);

  const loginResponse = useADLogin({ scopes: powerBiConfigScopes, prompt: powerBiPromptLogin });

  useDeepCompareEffect(() => {
    if (loginResponse?.loginSucces !== null) {
      if (loginResponse?.loginSucces) {
        setPowerBiAccessToken(loginResponse.token);
      } else {
        // ones you fail to login, you have multiple account, and you forced to choose one
        setPowerBiPromptLogin('select_account');
      }
    }
  }, [loginResponse]);

  const currentPowerBiReport = powerBiReports?.find(report =>
    report?.id === id && report?.reportType?.toLowerCase() === powerBi);

  return (
    <Div>
      <StyledDiv>
        <Flex fdc>
          {canShowReport ? <PowerBIEmbed
            embedConfig={{
              type: 'report', // Supported types: report, dashboard, tile, visual and qna
              id: currentPowerBiReport?.reportId,
              embedUrl: currentPowerBiReport?.reportUrl,
              accessToken: powerBiAccessToken,
              tokenType: models.TokenType.Aad,
              settings: {
                panes: {
                  filters: {
                    expanded: false,
                    visible: false,
                  },
                  pageNavigation: {
                    visible: false,
                  },
                  selection: {
                    visible: false,
                  },
                },
              },
            }}

            eventHandlers={
              new Map([
                ['error', (event) => {
                  if (event?.detail?.errorCode === '403') {
                    setCanShowReport(false);
                  }
                }],
              ])
            }

            cssClassName='power-bi-report'
            getEmbeddedComponent={(embeddedReport) => {
              window.report = embeddedReport;
            }}
          /> : intl.formatMessage({ id: 'powerBi.NO_ACCESS_WARNING' })}
        </Flex>
      </StyledDiv>
    </Div>
  );
};

PowerBiReport.propTypes = {
  id: PropTypes.string,
  intl: PropTypes.object,
};

export default injectIntl(PowerBiReport);

